import { ReactNode } from 'react';
import { AuthGuard as CommonAuthGuard } from '@cleanpro/common-ui';
import { useAuth } from '../hooks/useAuth';
import { AlertCircle } from 'lucide-react';

interface AuthGuardProps {
  children: ReactNode;
  requireRole?: string[];
  fallback?: ReactNode;
}

export default function AuthGuard({ 
  children, 
  requireRole = [], 
  fallback 
}: AuthGuardProps) {
  const authContext = useAuth();

  const unauthorizedComponent = (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center py-12">
        <AlertCircle className="h-16 w-16 text-red-500 mx-auto mb-4" />
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h2>
        <p className="text-gray-600 mb-4">
          You don't have permission to access this page.
        </p>
        <p className="text-sm text-gray-500">
          Required: {requireRole.join(', ')} | Your role: {authContext.user?.role || 'Unknown'}
        </p>
      </div>
    </div>
  );

  return (
    <CommonAuthGuard
      authContext={authContext}
      requireRole={requireRole}
      fallback={fallback}
      unauthorizedComponent={unauthorizedComponent}
    >
      {children}
    </CommonAuthGuard>
  );
}
